import { CommandSchema, StateSchema } from "@lenscore-pipeline/host-protocol";
/** Install the transport-neutral host contract on the browser window. */
export function installLensHost({ sendToHost, externalRenderer = true, }) {
    if (typeof window === "undefined")
        return;
    if (typeof sendToHost !== "function") {
        throw new TypeError("installLensHost: sendToHost must be a function");
    }
    const commandHandlers = new Set();
    const lensHost = {
        externalRenderer,
        onCommand(callback) {
            commandHandlers.add(callback);
            return () => commandHandlers.delete(callback);
        },
        commandResult(result) {
            sendToHost({ type: "commandResult", ...result });
        },
        setState(state) {
            // Convert readonly in-process snapshots to the validated mutable wire shape.
            sendToHost(StateSchema.parse({
                type: "state",
                ...state,
                activeLenses: state.activeLenses ? [...state.activeLenses] : undefined,
                lensErrors: state.lensErrors ? {
                    ...state.lensErrors,
                    issues: [...state.lensErrors.issues],
                    activeIssues: [...state.lensErrors.activeIssues],
                } : undefined,
            }));
        },
        ready(payload) {
            sendToHost({ type: "ready", payload });
        },
        log(level, message, detail) {
            sendToHost({ type: "log", level, message, detail });
        },
    };
    window.lensHost = lensHost;
    let nextId = 0;
    const lensCommand = (command, payload, requestId) => {
        if (commandHandlers.size === 0)
            return;
        const parsed = CommandSchema.safeParse({
            type: "command",
            requestId: typeof requestId === "string" && requestId.length > 0
                ? requestId
                : `host-${++nextId}`,
            command,
            payload,
        });
        if (!parsed.success) {
            console.warn("[lensHost] dropped malformed command:", parsed.error.format());
            return;
        }
        const validated = parsed.data;
        for (const callback of commandHandlers) {
            try {
                void callback(validated);
            }
            catch (error) {
                console.error("[lensHost] command handler threw:", error);
            }
        }
    };
    window.lensCommand = lensCommand;
}
//# sourceMappingURL=installLensHost.js.map